import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M2.5 12.5C2.5 12.5 6.5 5.5 12.5 5.5C18.5 5.5 22.5 12.5 22.5 12.5C22.5 12.5 18.5 19.5 12.5 19.5C6.5 19.5 2.5 12.5 2.5 12.5Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M12.5 15.5C14.1569 15.5 15.5 14.1569 15.5 12.5C15.5 10.8431 14.1569 9.5 12.5 9.5C10.8431 9.5 9.5 10.8431 9.5 12.5C9.5 14.1569 10.8431 15.5 12.5 15.5Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square"/>
  </svg>
)
